// A simple (non reactive) timer composable
export default function useTimer() {
  let startDate: Date | null = null;
  let timeInSeconds = 0;

  const startTimer = () => {
    startDate = new Date();
  };

  const pauseTimer = () => {
    if (startDate) {
      timeInSeconds += (new Date().getTime() - startDate.getTime()) / 1000;
      startDate = null;
    }
  };

  const resumeTimer = () => {
    if (!startDate) {
      startDate = new Date();
    }
  };

  const resetTimer = () => {
    startDate = null;
    timeInSeconds = 0;
  };

  const getTimeInSeconds = () => {
    if (startDate) {
      return (
        timeInSeconds + (new Date().getTime() - startDate.getTime()) / 1000
      );
    }
    return timeInSeconds;
  };

  return { startTimer, pauseTimer, resumeTimer, resetTimer, getTimeInSeconds };
}
